import React from 'react'
import Head from 'next/head'

type Props = {
  data: Record<string, any> | null | undefined
}

export const LDJson: React.FC<Props> = ({ data }: Props) =>
  data ? (
    <Head>
      <script
        // Setting a key here is important so Next can de-dupe meta tags, allowing
        // us to set "defaults" higher up the tree that individual components can
        // override if they want
        key="structured-data-react-sg-dxg"
        type="ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  ) : null
